import { DropEventArgs } from "client/Hooks";
import {
	Context,
	createContext,
	useContext
} from "react";

export type DropzoneContextData = {
	register: (
		acceptedTypes: readonly string[],
		callback: (args: DropEventArgs) => Promise<boolean>
	) => (() => void);
};

const DropzoneContext: Context<DropzoneContextData> = createContext<DropzoneContextData>({
	register: (): (() => void) => {
		return () => { /* NOOP */ };
	}
});

export const DropzoneContextProvider = DropzoneContext.Provider;

export function useDropzoneContext(): DropzoneContextData {
	return useContext(DropzoneContext);
}
